import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "product-variant-delivery-days"
};
const _hoisted_2 = {
    key: 0,
    class: "delivery-day__order-until"
};
const _hoisted_3 = { class: "delivery-day__order-until-date" };
const _hoisted_4 = { key: 1 };
import { onMounted, ref, computed, watch } from 'vue';
import moment from 'moment';
import WeekCalendar from '@astina/paloma-common-ui/src/components/WeekCalendar.vue';
import deliveryRepository from "../services/DeliveryRepository";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import env from "../services/AppEnv";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductVariantDeliveryDays',
    props: {
        itemNumber: {},
        variant: {}
    },
    setup(__props) {
        const props = __props;
        const options = ref([]);
        const displayDeliveryDays = ref(env.user.authenticated);
        onMounted(loadItemShippingOptions);
        watch(() => props.variant.sku, loadItemShippingOptions);
        function loadItemShippingOptions() {
            deliveryRepository.listItemShippingOptions([
                {
                    sku: props.variant.sku,
                    itemNumber: props.itemNumber,
                    deliveryGroup: props.variant.deliveryGroup,
                    availability: props.variant.availability
                }
            ]).then(data => {
                options.value = data.items[0].deliveryOptions;
            });
        }
        const events = computed(() => {
            return options.value.map(option => {
                const date = moment(option.deliveryDate);
                const event = {
                    date: date.toDate(),
                    title: trans('delivery.delivery_day'),
                    option: option,
                    latestOrderTimePassed: isLatestOrderTimePassed(option)
                };
                return event;
            });
        });
        function isLatestOrderTimePassed(opt) {
            if (!opt.latestOrderTime) {
                return false;
            }
            const lastOrderTime = moment(opt.latestOrderTime).toDate();
            return lastOrderTime.getTime() < Date.now();
        }
        return (_ctx, _cache) => {
            return (displayDeliveryDays.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(WeekCalendar, {
                        events: events.value,
                        "number-of-weeks": 2
                    }, {
                        title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('delivery.delivery_days')), 1)
                        ]),
                        event: _withCtx((props) => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["delivery-day", { 'delivery-day--passed': props.event.latestOrderTimePassed }])
                            }, [
                                (props.event.option.latestOrderTime)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('delivery.delivery_last_order_time')) + " ", 1),
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$dateTime(props.event.option.latestOrderTime)), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.event.title), 1))
                            ], 2)
                        ]),
                        _: 1
                    }, 8, ["events"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
